import React from 'react'
import Label from '../Input/Label'
// import { checkIfOnlyNumber } from '../../../utility'

export default class Output extends React.Component {
  render () {
    const { suffixAddon, style, leftItem, rightItem, inputRef, type } = this.props
    // textAreaRows, isHtmlFormatted - from props
    // const isTextArea = type === 'TEXTAREA'
    // const lineHeightValue = window.getComputedStyle(document.body).getPropertyValue('--inputLineHeight')
    // const paddingValue = window.getComputedStyle(document.body).getPropertyValue('--inputPadding')
    // const paddingValueArr = paddingValue?.split(' ').filter(val => val.length)
    // const inputPadding = paddingValueArr[0] === paddingValueArr[2] || !paddingValueArr[2] ? `2 * ${paddingValueArr[0]}` : `${paddingValueArr[0]} + ${paddingValueArr[2]}`
    // const hasLineHeightUnits = checkIfOnlyNumber(lineHeightValue)
    // const lineBoxHeight = !hasLineHeightUnits ? 'var(--inputLineHeight) * var(--inputFontSize)' : 'var(--inputLineHeight)'
    // const textAreaHeight = isHtmlFormatted ? `${textAreaRows}rem` : `calc((${textAreaRows} * ${lineBoxHeight}) + ${inputPadding} + 2px)`
    return (
      <div ref={inputRef} className='output' style={style}>
        <div className='output-wrapper'>
          <div className='output-box'>
            <div className='left'>{leftItem}</div>
            {this.props.children}
            {suffixAddon ? <span className='suffix'>{suffixAddon}</span> : null}
            <div className='right'>{rightItem}</div>
          </div>
          <Label {...this.props} />
        </div>

        <style jsx>{`
        .output {
        .right {
          order: 4
        }
        .suffix {
          order: 3
        }
        .left {
          order: 1
        }
        .output-wrapper {
          display: flex;
          flex-direction: column;
          > .output-box {
            min-height: 15px;
            display: flex;
            flex-direction: row;
            order: 2;
            padding-left: ${type === `IMAGE` ? 0 : `12px`};
          }

          :global(.icon-left) {
            margin-right: 0.5rem;
          }
          .suffix  {
            margin-right: 1rem;
          }
        }
        
        .output-box :global(ul) {
          list-style: revert;
          padding: revert;
        }
        
        .output-box :global(a) {
          display: flex;
          align-items: center;
        }
}
        `}</style>
      </div>
    )
  }
}
